export const key: string | undefined = process.env.ENCRYPT_SECRET;
